<v-form
  (valueChange)="formValueChange($event)"
  *ngIf="{
    disabled: disabled$ | async,
    prefill: mappedPrefill$ ? (mappedPrefill$ | async) : null
  } as obs"
>
  <v-input
    name="configurationTitle"
    [title]="'configurationTitle' | pluginTranslate : pluginId | async"
    [margin]="true"
    [disabled]="obs.disabled"
    [defaultValue]="obs.prefill?.configurationTitle"
    [required]="true"
    [tooltip]="'configurationTitleTooltip' | pluginTranslate : pluginId | async"
    placeholder="Griffie Plugin"
  >
  </v-input>
  <v-multi-input-form
    name="griffieProperties"
    [title]="'organizations' | pluginTranslate : pluginId | async"
    [formTemplate]="mappingForm"
    [addRowText]="'addGriffieType' | pluginTranslate : pluginId | async"
    [required]="false"
    [tooltip]="'organizationsTooltip' | pluginTranslate : pluginId | async"
    (deleteRowEvent)="deleteRow($event)"
    [initialAmountOfRows]="0"
    [minimumAmountOfRows]="0"
    [defaultValues]="obs.prefill?.griffieProperties"
  >
  </v-multi-input-form>
</v-form>

<ng-template #mappingForm let-index="index" let-uuid="uuid" let-changeFunction="changeFunction" let-prefill="prefill">
  <ng-container
    *ngIf="{
      disabled: disabled$ | async
    } as obs"
  >
    <v-form (valueChange)="changeFunction($event, uuid); griffieTypeFormChange($event, uuid)">
      <v-input
        name="name"
        [title]="'bronorganisatieName' | pluginTranslate : pluginId | async"
        [margin]="false"
        [disabled]="obs.disabled"
        [defaultValue]="prefill?.name"
        [required]="true"
        [tooltip]="'bronorganisatieNameTooltip' | pluginTranslate : pluginId | async"
        [smallMargin]="true"
        placeholder=""
      >
      </v-input>
      <v-input
        name="bronorganisatie"
        [title]="'bronorganisatie' | pluginTranslate : pluginId | async"
        [margin]="false"
        [disabled]="obs.disabled"
        [defaultValue]="prefill?.bronorganisatie"
        [required]="true"
        [tooltip]="'bronorganisatieTooltip' | pluginTranslate : pluginId | async"
        [smallMargin]="true"
        placeholder=""
      >
      </v-input>
      <v-input
        name="groupMail"
        [title]="'groupMail' | pluginTranslate : pluginId | async"
        [margin]="false"
        [disabled]="obs.disabled"
        [defaultValue]="prefill?.groupMail"
        [required]="true"
        [tooltip]="'groupMailTooltip' | pluginTranslate : pluginId | async"
        [smallMargin]="true"
        placeholder=""
      >
      </v-input>
      <v-input
        name="candidateGroup"
        [title]="'candidateGroup' | pluginTranslate : pluginId | async"
        [margin]="false"
        [disabled]="obs.disabled"
        [defaultValue]="prefill?.candidateGroup"
        [required]="true"
        [tooltip]="'candidateGroupTooltip' | pluginTranslate : pluginId | async"
        [smallMargin]="true"
        placeholder=""
      >
      </v-input>
      <!-- <v-input class="hidden-input" name="uuid" [defaultValue]="uuid"> </v-input> -->
    </v-form>
  </ng-container>
</ng-template>
